import { ChannelRef, MeasurementPoint, Source } from '@core/models/installation.model';

type ChannelCoordinates = Pick<
  Source,
  'deviceId' | 'ldn' | 'contextType' | 'contextNumber' | 'valueName'
>;

// The checklist names a channel by its coordinates alone, where a binding's source carries more.
export function channelOfRef(ref: ChannelRef): ChannelCoordinates {
  return { ...ref, ldn: ref.deviceLdn };
}

// A channel has no oid: the reader's four coordinates are what identify it.
export function channelKey(source: Omit<ChannelCoordinates, 'ldn'>): string {
  return [source.deviceId, source.contextType, source.contextNumber, source.valueName].join('/');
}

export interface ChannelFields {
  device_id: number;
  context_type: string;
  context_number: number;
  value_name: string;
}

// Null for a source that is not a device channel, which has no coordinates to send.
export function channelFields(source: Source): ChannelFields | null {
  const { deviceId, contextType, contextNumber, valueName } = source;
  if (deviceId === null || contextType === null || contextNumber === null || valueName === null) {
    return null;
  }
  return {
    device_id: deviceId,
    context_type: contextType,
    context_number: contextNumber,
    value_name: valueName,
  };
}

export function channelLabel(source: ChannelCoordinates): string {
  const device = source.ldn ?? source.deviceId;
  const context = [source.contextType, source.contextNumber].filter(part => part !== null);
  return [device, context.join(' '), source.valueName]
    .filter(part => part !== null && part !== '')
    .join(' · ');
}

export function pointName(points: readonly MeasurementPoint[], pointOid: string): string | null {
  return points.find(point => point.pointOid === pointOid)?.name ?? null;
}
